module.exports = __webpack_public_path__ + "img/navigation-next.7654cdcb.svg";